import React from "react";
import { Skeleton } from "antd";
import { PATH_ALBUM } from "../../constants/album";
import HTMLElementWithEvent from "./HTMLElementWithEvent";
import { Download, Edit3, MessageSquare, Tag } from "react-feather";
import { FaRegStar, FaStar } from "react-icons/fa";
import { ACTION_ALBUM } from "../../constants/album";
import { getLikeAnoButton, getTagDeleteButton, getRecommendedUserButton } from "./PhotoActions";
import { LoadingOutlined } from "@ant-design/icons";

export default function Card({
  image,
  i,
  checkedPath,
  tagShow,
  setTagShow,
  setIsModalOpen,
  setIsError,
  mutateRecommend,
  mutateLiked,
  albumDetail,
  isCommentPassword,
  isDownloadable,
  t,
  toggleTag,
  handleImageLoad,
  aspectRatio,
}) {
  return (
    <div key={image?.id} className="pb-2">
      <div key={i} className="relative">
        <div className="pswp-gallery__item" id={i.toString()}>
          <a
            href={image?.url}
            data-thumb-src={image?.url}
            data-pswp-width={window.innerWidth}
            data-pswp-height={
              aspectRatio
                ? aspectRatio * window.innerWidth
                : "auto"
            }
            rel="noreferrer"
          >
            <div className="relative w-full">
              {!aspectRatio && <Skeleton active className="w-full h-full" />}
              <img
                id={`photo${image?.id}`}
                src={image?.url}
                className="block w-full"
                alt={image?.file_name}
                onClick={(e) => {
                  e.preventDefault();
                }}
                onLoad={(e) => handleImageLoad(i, e)}
              />
              {tagShow.includes(image.id) && (
                <div className="absolute top-0 left-0 w-full h-full bg-black/50 flex items-center justify-center">
                  <div className="flex w-max flex-wrap min-w-32 max-w-64 items-center justify-center gap-1">
                    {image.tags.map((tag, index) => (
                      <span
                        className="tag-item max-w-32 whitespace-nowrap overflow-hidden text-ellipsis ml-1 text-xs px-2 py-1 rounded-lg bg-secondary opacity-80 hover:bg-secondary hover:opacity-100 transition-all"
                        key={index}
                      >
                        {tag.name}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </a>
          <div className="pswp-caption-content hidden w-full mx-4">
            <div
              key={i}
              className="flex sm:flex-row flex-col justify-center sm:justify-between items-center m-5"
            >
              <div className="w-full lg:w-64">{image?.file_name}</div>
              {!checkedPath.includes(PATH_ALBUM.SHOW) && (
                <div className="comment-wrap flex gap-1 flex-col w-full sm:w-auto flex-1">
                  <div
                    className={`comment text-xs ${
                      image?.comments[0]?.comment
                        ? "rounded-md bg-[#414141] text-yellow-50 hover:bg-[#414141] py-1 px-1 lg:py-2 lg:px-3"
                        : ""
                    }`}
                    id={`comment-${i}`}
                  >
                    {image?.comments[0]?.comment}
                  </div>
                  <div className={`tag text-xs tag-wrap tag-wrap-${i}`}>
                    {image?.tags?.map((tag, index) => (
                      <HTMLElementWithEvent
                        element={getTagDeleteButton(
                          checkedPath.includes(PATH_ALBUM.DASHBOARD),
                          i,
                          tag,
                          (index, id) => toggleTag(index, id)
                        )}
                        key={index}
                      />
                    ))}
                  </div>
                </div>
              )}
              <div className="justify-self-end flex gap-2 items-center justify-end w-full lg:w-64">
                {checkedPath.includes(PATH_ALBUM.ANO) && isCommentPassword && (
                  <div className="w-10 h-10 flex gap-1 justify-center items-center cursor-pointer transition-all hover:bg-gray-200/40 rounded-full edit-comment">
                    <Edit3 className="w-5" />
                  </div>
                )}
                {checkedPath.includes(PATH_ALBUM.ANO) &&
                  albumDetail.tags?.length > 0 && (
                    <div className="relative" id={`tag-${i}`}>
                      <div className="w-10 h-10 flex gap-1 justify-center items-center cursor-pointer transition-all hover:bg-gray-200/40 rounded-full add-tag">
                        <Tag className="w-5" />
                      </div>
                    </div>
                  )}
                {!checkedPath.includes(PATH_ALBUM.SHOW) && (
                  <div
                    id={`like-sl-${i}`}
                    dangerouslySetInnerHTML={{
                      __html: getLikeAnoButton(
                        image?.is_liked,
                        checkedPath.includes(PATH_ALBUM.DASHBOARD)
                      ),
                    }}
                  />
                )}

                {isDownloadable && (
                  <a
                    href={image?.url}
                    target="_blank"
                    data-file_name={image.file_name}
                    rel="noreferrer"
                    className="w-10 h-10 flex gap-1 justify-center items-center cursor-pointer transition-all hover:bg-gray-200/40 rounded-full download"
                  >
                    <div className="relative">
                      <Download className="w-5 download-icon-file" />
                      <LoadingOutlined className="hidden loader-icon-file" />
                    </div>
                  </a>
                )}

                {checkedPath.includes(PATH_ALBUM.DASHBOARD) && (
                  <div className="h-10 flex gap-1 justify-center items-center cursor-pointer transition-all rounded-full change-thumbnail">
                    <div className="h-5 underline rounded-full flex items-center justify-center">
                      {t("albumDetail.album.setAsCover")}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {aspectRatio && !checkedPath.includes(PATH_ALBUM.SHOW) && (
          <>
            <div
              id={`recommend-${i}`}
              className={`p-2 absolute top-1 left-1 ${
                checkedPath.includes(PATH_ALBUM.DASHBOARD)
                  ? "cursor-pointer transition-all hover:bg-gray-200/40 rounded-full"
                  : "cursor-default"
              } ${
                checkedPath.includes(PATH_ALBUM.ANO) && !image?.is_recommended
                  ? "hidden"
                  : ""
              }`}
              onClick={() => {
                if (checkedPath.includes(PATH_ALBUM.DASHBOARD)) {
                  if (albumDetail.is_locked) {
                    setIsModalOpen(ACTION_ALBUM.LOCK);
                    return;
                  }
                  mutateRecommend(image.id, {
                    onSuccess: () => {
                      image.is_recommended = image.is_recommended ? 0 : 1;

                      const rcm = document.getElementById("recommend-sl-" + i);
                      if (rcm) {
                        rcm.closest(".pswp__recommended-button").innerHTML =
                          getRecommendedUserButton(
                            image.is_recommended,
                            checkedPath.includes(PATH_ALBUM.DASHBOARD),
                            t("albumDetail.album.isRecommended")
                          );
                      }
                    },
                  });
                }
              }}
            >
              {!!image?.is_recommended ? (
                <FaStar className="text-secondary text-xl opacity-90" />
              ) : (
                <FaRegStar className="text-gray-600 text-xl opacity-90" />
              )}
            </div>
            <div
              id={`like-${i}`}
              className={`p-2 absolute top-1 right-1 ${
                checkedPath.includes(PATH_ALBUM.DASHBOARD) && !image?.is_liked
                  ? "hidden"
                  : "rounded-full transition-all hover:bg-gray-200/40"
              }`}
              onClick={(e) => {
                if (checkedPath.includes(PATH_ALBUM.ANO)) {
                  if (albumDetail.is_locked) {
                    setIsModalOpen(ACTION_ALBUM.LOCK);
                    return;
                  }
                  image.is_liked = image.is_liked ? 0 : 1;
                  const like = document.querySelectorAll("#like-sl-" + i);
                  if (like) {
                    for (let key = 0; key < like.length; key++) {
                      like[key].innerHTML = getLikeAnoButton(
                        image.is_liked,
                        checkedPath.includes(PATH_ALBUM.DASHBOARD)
                      );
                      // like[key].addEventListener("click", (e) => {
                      //   likeF(i, e);
                      // });
                    }
                  }
                  mutateLiked(image.id, {
                    onSuccess: () => {},
                    onError: (error) => {
                      image.is_liked = image.is_liked ? 0 : 1;
                      if (like) {
                        for (let key = 0; key < like.length; key++) {
                          like[key].innerHTML = getLikeAnoButton(
                            image.is_liked,
                            checkedPath.includes(PATH_ALBUM.DASHBOARD)
                          );
                          // like[key].addEventListener("click", (e) => {
                          //   likeF(i, e);
                          // });
                        }
                      }
                      if (error.response?.data?.message === "CANNOT_LIKE_FILE")
                        setIsError("like");
                      if (error.response?.data?.message === "ALBUM_IS_LOCKED")
                        setIsModalOpen(ACTION_ALBUM.LOCK);
                    },
                  });
                }
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: getLikeAnoButton(
                    image?.is_liked,
                    checkedPath.includes(PATH_ALBUM.DASHBOARD)
                  ),
                }}
              ></div>
            </div>
            <div
              className={`p-2 absolute bottom-0 right-0 ${
                !image?.comments[0]?.comment ? "hidden" : ""
              }`}
            >
              <MessageSquare className="text-secondary text-xl" />
            </div>
            <div
              className={`p-2 absolute bottom-0 left-0 cursor-pointer transition-all hover:bg-gray-200/40 rounded-full ${
                !image?.tags?.length ? "hidden" : ""
              }`}
              onClick={() =>
                tagShow.includes(image.id)
                  ? setTagShow(tagShow.filter((id) => id !== image.id))
                  : setTagShow([...tagShow, image.id])
              }
            >
              <Tag height={22} className="text-secondary text-xl" />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
